import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchEdgeDataThunk, makeFetchSlice } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'

import { DomainType } from 'features/domains/types'
import { fetchRootDomains } from './api'
import {
  CURRENT_ROOT_ID_REDUCER_NAME,
  LOCALSTORAGE_SELECTED_ROOT,
  ROOT_DOMAINS_DATA_REDUCER_NAME,
} from './consts'

const rootDomainsDataSlice = makeFetchSlice<DomainType[]>(
  ROOT_DOMAINS_DATA_REDUCER_NAME
)
export const rootDomainsDataReducer = rootDomainsDataSlice.reducer
export const rootDomainsDataActions = rootDomainsDataSlice.actions

export const fetchRootDomainsThunk = () => {
  return async (dispatch: AppDispatch) => {
    try {
      const resp = await fetchEdgeDataThunk({
        dispatch,
        actions: rootDomainsDataActions,
        asyncFunc: () => fetchRootDomains(),
      })
      return resp
    } catch (error) {
      // we need to clear rootDomainsData state here because if we get 401 error axios interceptor will do logout and clear state
      // but rootDomainsData succeed action will be dispatched right after storeReset, and useRootDomainId hook will do logout on next login
      // because in state we will have some of this conditions true - hasRootDomainsError || (isFinishedRootDomains && isEmpty(rootDomains))
      dispatch(rootDomainsDataActions.clear())
      console.log('Error fetching root domains', error)
    }
  }
}

type CurrentRootIdState = string | null

const currentRootinitialState = null as CurrentRootIdState

export const currentRootIdSlice = createSlice({
  name: CURRENT_ROOT_ID_REDUCER_NAME,
  initialState: currentRootinitialState,
  reducers: {
    setId(state, action: PayloadAction<string>) {
      if (action.payload !== state) {
        state = action.payload
      }
      return state
    },
  },
  extraReducers: (builder) => {
    builder.addCase(rootDomainsDataActions.succeed, (state, action) => {
      // When initial root domains are fetched - set currentRootId
      if (!state) {
        // Check if rootDomainId from localStorage exists in fetched user's roots
        const localStorageRootId = localStorage.getItem(
          LOCALSTORAGE_SELECTED_ROOT
        )
        if (
          action.payload.filter(
            (domain: DomainType) => domain.id === localStorageRootId
          ).length
        ) {
          return localStorageRootId
        } else {
          // Either way - select first domain from user's roots array
          const firstDomainInRootDomains = action.payload?.[0]
          const firstDomainIdInRootDomains = firstDomainInRootDomains.id
          if (firstDomainIdInRootDomains) {
            localStorage.setItem(
              LOCALSTORAGE_SELECTED_ROOT,
              firstDomainIdInRootDomains
            )
            return firstDomainIdInRootDomains
          }
        }
      } else {
        return null
      }
    })
  },
})
